import type { ReactNode } from "react";
import type {
  DataStoryStepContext,
  StoryGoalField,
  StorySourcesFields,
} from "../../../services/dataStories/dataStoryFlow.types";

/** The slice of a details step's values this molecule reads and patches. */
export type StoryDetailsFieldsValues = StoryGoalField & StorySourcesFields;

/**
 * StoryDetailsFields — the Goal input and the Sources picker as the
 * create-data-story details frames draw them, with a slot between the two.
 *
 * Both details frames that draw sources (AI 5326:88121, agent 5326:88960) show
 * Goal first and Sources last; the AI frame puts its Audience field between
 * them. That slot is why this is one component with `children` rather than two
 * separate goal/sources molecules — the frames differ only in what sits in the
 * middle, so neither frame repeats the sources picker's prop wiring.
 */
export interface StoryDetailsFieldsProps {
  values: StoryDetailsFieldsValues;
  /** Merges a partial patch into the owning step's values. */
  onChange: (patch: Partial<StoryDetailsFieldsValues>) => void;
  /**
   * Workspace lists and the popover boundary ref. Optional so a bare story or
   * test can render the fields with empty pickers.
   */
  context?: DataStoryStepContext;
  /** Rendered between Goal and Sources — the AI frame's Audience field. */
  children?: ReactNode;
}

/** Dropdown label when no data model is picked — Figma shows the placeholder. */
export const NO_MODEL_LABEL = "Select a data model";
